import { Spacing } from '@persona-id/design-tokens';
import { Fragment } from 'react';
import styled from 'styled-components';

import {
  LoadingShimmerHeading,
  LoadingShimmerParagraph,
} from 'dashboard/components/LoadingShimmer/LoadingShimmer';
import Card from 'design-system/components/Card';
import Spacer from 'design-system/components/Spacer';
import { BASE } from 'design-system/variables/spacing';

const FirstCard = styled.div`
  display: grid;
  grid-template-columns: 35% 10%;
  grid-template-rows: repeat(5, auto);
  grid-column-gap: ${BASE * 10}px;
  grid-row-gap: ${Spacing[4]};
`;

const StyledLoadingShimmerHeading = styled(LoadingShimmerHeading)<{ gridColumn: string }>`
  grid-column: ${({ gridColumn }) => gridColumn};
  grid-row: 1;
  margin-bottom: ${Spacing[2]};
`;

const SecondCard = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 15%);
  grid-template-rows: repeat(4, auto);
  grid-column-gap: 27.5%;
  grid-row-gap: ${Spacing[4]};
`;

const StyledLoadingShimmerParagraph = styled(LoadingShimmerParagraph)`
  display: block;
`;

const FIRST_CARD_NUM_ROWS = 4;

const SECOND_CARD_NUM_ITEMS = 9;

interface LoadingResultProps {
  multiCardFormat: boolean;
}

export default ({ multiCardFormat = false }: LoadingResultProps) => {
  const firstCardContent = (
    <FirstCard>
      <StyledLoadingShimmerHeading size='md' width='60%' gridColumn='1 / 3' />
      {[...Array(FIRST_CARD_NUM_ROWS)].map((_, i) => {
        return (
          <Fragment key={i}>
            <LoadingShimmerParagraph size='md' width={`${i % 2 === 0 ? '100%' : '80%'}`} />
            <LoadingShimmerParagraph size='md' width={`${i % 2 === 0 ? '100%' : '80%'}`} />
          </Fragment>
        );
      })}
    </FirstCard>
  );

  return multiCardFormat ? (
    <>
      <Card>
        <Card.Body>{firstCardContent}</Card.Body>
      </Card>
      <Card>
        <Card.Body>
          <SecondCard>
            <StyledLoadingShimmerHeading size='md' width='30%' gridColumn='1 / 4' />
            {[...Array(SECOND_CARD_NUM_ITEMS)].map((_, i) => (
              <div key={i}>
                <StyledLoadingShimmerParagraph size='md' width='100%' />
                <Spacer height={1.5} />
                <StyledLoadingShimmerParagraph size='md' width='70%' />
              </div>
            ))}
          </SecondCard>
        </Card.Body>
      </Card>
    </>
  ) : (
    firstCardContent
  );
};
